/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSocialInstagram24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.052.072C8.332.014 8.741 0 12 0c3.259 0 3.668.014 4.948.072 1.95.089 3.663.567 5.038 1.942 1.375 1.375 1.853 3.088 1.942 5.038C23.986 8.332 24 8.741 24 12c0 3.259-.014 3.668-.072 4.948-.089 1.95-.567 3.663-1.942 5.038-1.375 1.375-3.088 1.853-5.038 1.942-1.28.058-1.689.072-4.948.072-3.259 0-3.668-.014-4.948-.072-1.95-.089-3.663-.567-5.038-1.942C.639 20.611.161 18.898.072 16.948.014 15.668 0 15.259 0 12c0-3.259.014-3.668.072-4.948.089-1.95.567-3.663 1.942-5.038C3.389.639 5.102.161 7.052.072zm9.797 2.16c-1.265-.058-1.645-.07-4.849-.07s-3.584.012-4.849.07c-1.366.062-2.633.336-3.608 1.311-.975.975-1.249 2.242-1.311 3.608-.058 1.265-.07 1.645-.07 4.849s.012 3.584.07 4.849c.062 1.366.336 2.633 1.311 3.608.975.975 2.242 1.249 3.608 1.311 1.265.058 1.645.07 4.849.07s3.584-.012 4.849-.07c1.366-.062 2.633-.336 3.608-1.311.975-.975 1.249-2.242 1.311-3.608.058-1.265.07-1.645.07-4.849s-.012-3.584-.07-4.849c-.062-1.366-.336-2.633-1.311-3.608-.975-.975-2.242-1.249-3.608-1.311zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM8 12a4 4 0 108 0 4 4 0 00-8 0zm11.846-6.406a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z'
      />
    </svg>
  );
}

export default SvgSocialInstagram24;
